export function handleBackendError(apiName, result = null) {
    console.log('API Error', apiName, result ? result.error : '');
    if (result) {
        console.log(' --- full response object', result);
    }
    window.alert(`API ${apiName} Error ${result?.error || ''}`);
    window.location.reload();
}
